import { useEffect, useState } from "react"
import api from "../utils/api"

const useHasVoted = (voterId: string, instanceId: string) => {
  const [hasVoted, setHasVoted] = useState<boolean | null>(null)

  useEffect(() => {
    const checkVoterStatus = async () => {
      try {
        const { data } = await api.get(
          `/voter/${voterId}/hasVoted/${instanceId}`
        )
        setHasVoted(data.hasVoted)
      } catch (error) {
        console.error("Error checking voter status:", error)
      }
    }

    if (voterId && instanceId) {
      checkVoterStatus()
    }
  }, [voterId, instanceId])

  return hasVoted
}

export default useHasVoted
